module.exports = __webpack_public_path__ + "static/media/hardy-thinking.6e6abfa2.svg";